<h2 mat-dialog-title>Création d'un dossier</h2>

<mat-dialog-content>
  <form [formGroup]="actCreationFG">
    <div class="tmplList">
      <mat-form-field *ngIf="dcbmServices.length > 1">
        <mat-label>Service DCBM</mat-label>
        <input type="text" matInput formControlName="service" [matAutocomplete]="auto2" [errorStateMatcher]="matcherTemplate" />
        <button
          *ngIf="actCreationFG.value.service"
          matSuffix
          mat-icon-button
          aria-label="Clear"
          (click)="actCreationFG.controls.service.patchValue('')"
        >
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>

      <mat-autocomplete #auto2="matAutocomplete" [displayWith]="displayServiceFn">
        <mat-option *ngFor="let service of filteredServices | async" [value]="service">
          {{ service.name }}
        </mat-option>
      </mat-autocomplete>

      <mat-form-field>
        <mat-label>Type de dossier</mat-label>
        <input type="text" matInput formControlName="template" [matAutocomplete]="auto1" [errorStateMatcher]="matcherTemplate" />
        <button
          *ngIf="actCreationFG.value.template"
          matSuffix
          mat-icon-button
          aria-label="Clear"
          (click)="actCreationFG.controls.template.patchValue('')"
        >
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>

      <mat-autocomplete #auto1="matAutocomplete" [displayWith]="displayTemplateFn">
        <mat-option *ngFor="let template of filteredTemplates | async" [value]="template">
          {{ template.name }}
        </mat-option>
      </mat-autocomplete>
    </div>

    <mat-form-field>
      <mat-label>Nom du dossier</mat-label>
      <input type="text" matInput formControlName="name" />
    </mat-form-field>

    <mat-form-field>
      <mat-label>Description du dossier</mat-label>
      <textarea matInput formControlName="description"></textarea>
    </mat-form-field>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Annuler</button>
  <button mat-button (click)="validate()" [disabled]="!isValid()">Valider</button>
</mat-dialog-actions>
